<template>
    <div>
        <div>Hello {{ value }}</div>
        <div>UserData {{ user }}</div>
        <div>API {{ apiresponse }}</div>
        <input @click="getData" type=button value="メッセージを取得" >
    </div>
</template>

<script>

export default {
  name: "Home",
  data() {
    return {
      value: "World",
      user: "none",      
      apiresponse: "none"
    };
  },
  methods: {
    getData: async function() {
      this.value = "Change!";
      this.axios.get('/.auth/me')
        .then((response) => {
          // alert(response.data.clientPrincipal);
          this.user = response.data.clientPrincipal;
        })
        .catch((e) => {
          alert(e);
        });

      this.axios.get('/api/message')
        .then((response) => {
          alert(response.data);
          this.apiresponse = response.data;
        })
        .catch((e) => {
          alert(e);
        });
    }
  }
};
</script>
